<template lang="pug">
div
  v-card(flat)
    v-card-title Site Information
    keep-alive
      validation-observer(ref="o07" v-slot="{ invalid }" :persist="true" vid="o07")
        v-container
          v-row
            v-col(:lg="12" :md="12" :sm="12" :cols="12")
              p.pb-0.pl-8.text--secondary Failure to provide the following information may slow down or impede the application process.
              p.pb-0.pl-8.text--secondary Contact the Department of Parks and Recreation to reserve a facility, park site, trail or shelter:
              ul.pl-16
                li.text--secondary call 703-228-1805
                li.text--secondary email <a href="mailto:facilitiesscheduling@arlingtonva.us">facilitiesscheduling@arlingtonva.us</a>
                li.text--secondary visit <a target="_blank" href="https://parks.arlingtonva.us/rentals/">parks.arlingtonva.us/rentals/</a>
              p.pb-0.pl-8.text--secondary Rentals must be reserved and paid in advance.
              p.pb-0.pl-8.text--secondary If you would like to utilize Arlington County Fire Department Information Education Services at your event, contact the Arlington County Fire Prevention Division at 703-228-4644 for more information.
              p.pb-0.pl-8.text--secondary Arlington County's portable performance stage is available for rental in certain locations. Call 703-228-1845 for more information.
          v-row
            v-col(:lg="12" :md="12" :sm="12" :cols="12")
              p.pb-0.body-1 Are you interested in using the mobile stage?
              validation-provider(rules="required", v-slot="{ errors }" immediate)
                v-radio-group(v-model="SEA_MobileStage" row dense :disabled="disabled")
                  v-radio(
                    v-for="option in yesNoString",
                    :key="option"
                    :label="option"
                    :value="option"
                  )
                p.pb-0.red--text.text--lighten-1.pl-4 {{ errors[0] }}
          v-row
            v-col(:lg="12" :md="12" :sm="12" :cols="12")
              p.pb-0.body-1 Attach or provide a link to a map showing the following:
              ul.pl-16
                li.text--secondary Activity areas/tents/kiosks/structures
                li.text--secondary Area where alcohol will be served
                li.text--secondary Restrooms/portable toilets
                li.text--secondary Sign plan showing publicity, directional and day-of-event signs
                li.text--secondary Map of trail event showing entire course
                li.text--secondary Food/cooking/hand washing facilities
                li.text--secondary Music/bandstand area/speakers/sound booth
                li.text--secondary Parking areas/shuttle bus stops
                li.text--secondary Public parking restrictions
                li.text--secondary First Aid station
                li.text--secondary Street barricades and/or closures
              p.pb-0.pl-8.text--secondary You may also fax the map to 703-228-3328. 
              p.pb-0.red--text.text--lighten-1 Failure to include a site plan will result in the application not being approved.
          v-row(v-if="id")
            v-col(:lg="12" :md="12" :sm="12" :cols="12")
              p.pb-0.body-1 Site Plan Map Upload
              o07sitePlanUpload(v-bind:docId="id")
          v-row(v-else)
            v-col(:lg="12" :md="12" :sm="12" :cols="12")
              p.pb-0.red--text.text--lighten-1.pl-4 To attach a Site Plan Map, you must first save your work. 
              p.pb-0.red--text.text--lighten-1.pl-4 Click save below. If it&apos;s greyed-out, return to the Submitter tab and provide an email address.
          v-row
            v-col(:lg="12" :md="12" :sm="12" :cols="12")
              p.pb-0.body-1 Site Plan Map URL
              validation-provider(
                :rules="{max: 250, regex: /^((?!google).)*$/g }", 
                v-slot="{ errors }" immediate
                )
                v-text-field.pb-3.pl-3(
                  id="planUrl"
                  outlined,
                  hide-details,
                  dense,
                  v-model="SEA_PlanURL"
                  :disabled="disabled"
                  maxlength="251",
                )
                p.pb-0.red--text.text--lighten-1.pl-4 {{ errors[0] ? 'Please do not use a Bing or Google Map Coordinate URL. Your URL must be less than 250 characters.' : '' }}
          v-row
            v-col(:lg="12" :md="12" :sm="12" :cols="12")
              p.pb-0.body-1 Will the event have tents and/or temporary membrane structures?
              validation-provider(rules="required", v-slot="{ errors }" immediate)
                v-radio-group(v-model="SEA_Tents" row dense :disabled="disabled")
                  v-radio(
                    v-for="option in yesNoString",
                    :key="option"
                    :label="option"
                    :value="option"
                  )
                p.pb-0.red--text.text--lighten-1.pl-4 {{ errors[0] }}
          v-row(v-if="SEA_Tents === 'Yes'")
            v-col(:lg="12" :md="12" :sm="12" :cols="12")
              p.pb-0.body-1 Will any of the tents be greater than 100 square feet?
              validation-provider(rules="required", v-slot="{ errors }" immediate)
                v-radio-group(v-model="SEA_Permit_OCCRequired_5" row dense :disabled="disabled")
                  v-radio(
                    v-for="option in yesNoString",
                    :key="option"
                    :label="option"
                    :value="option"
                  )
                p.pb-0.red--text.text--lighten-1.pl-4 {{ errors[0] }}
          v-row(v-if="SEA_Permit_OCCRequired_5 === 'Yes'")
            v-col(:lg="12" :md="12" :sm="12" :cols="12")
              p.pb-0.body-1 Certificate of Occupancy for Tents Greater than 100 Square Feet
              p.pb-0.pl-8.text--secondary Any tent greater than 100 square feet, whether or not they are used for cooking, must have an approved Certificate of Occupancy from the Department of Community Planning, Housing, and Development, Zoning Office at 703-228-3883.
          v-row
            v-col(:lg="12" :md="12" :sm="12" :cols="12")
              p.pb-0.body-1 Will any structure (including stages) be greater than 900 square feet or occupied by more than 50 persons?
              validation-provider(rules="required", v-slot="{ errors }" immediate)
                v-radio-group(v-model="SEA_Permit_BUILDRequired_6" row dense :disabled="disabled")
                  v-radio(
                    v-for="option in yesNoString",
                    :key="option"
                    :label="option"
                    :value="option"
                  )
                p.pb-0.red--text.text--lighten-1.pl-4 {{ errors[0] }}
          v-row(v-if="SEA_Permit_BUILDRequired_6 === 'Yes'")
            v-col(:lg="12" :md="12" :sm="12" :cols="12")
              p.pb-0.body-1 Building Permit for Structures Greater than 900 Square Feet or Stages
              p.pb-0.pl-8.text--secondary Any structure (such as a stage) greater than 900 square feet or occupied by more than 50 persons must have an approved Building Permit from Arlington County Inspection Services at 703-228-3800.
          v-row
            v-col(:lg="12" :md="12" :sm="12" :cols="12")
              p.pb-0.body-1 Does the event include any amusement devices or structures for entertainment? Examples include moon bounce house, rock climbing wall or large inflatable toys or props.
              v-radio-group(v-model="SEA_AmusementDevices" row dense :disabled="disabled")
                v-radio(
                  v-for="option in yesNoString",
                  :key="option"
                  :label="option"
                  :value="option"
                )
          div.d-flex.align-center(v-if="SEA_AmusementDevices === 'Yes'" :style={paddingLeft: '40px'})
            p.pb-0.body-1 Please describe the amusement devices and/or structures.
          v-row(v-if="SEA_AmusementDevices === 'Yes'" :style={paddingLeft: '40px'})
            v-col(:lg="12" :md="12" :sm="12" :cols="12")
              v-textarea.pb-3.pl-3(outlined hide-details dense v-model="SEA_AmusementDeviceDesc" :disabled="disabled" )
          v-row
            v-col(:lg="12" :md="12" :sm="12" :cols="12")
              p.pb-0.body-1 Does the event require electrical usage?
              validation-provider(rules="required", v-slot="{ errors }" immediate)
                v-radio-group(v-model="SEA_Permit_ElectricalRequired_11" row dense :disabled="disabled")
                  v-radio(
                    v-for="option in yesNoString",
                    :key="option"
                    :label="option"
                    :value="option"
                  )
                p.pb-0.red--text.text--lighten-1.pl-4 {{ errors[0] }}
          v-row(v-if="SEA_Permit_ElectricalRequired_11 === 'Yes'" :style={paddingLeft: '40px'})
            v-col(:lg="12" :md="12" :sm="12" :cols="12")
              p.pb-0.body-1 Electrical Needs
              p.pb-0.pl-8.text--secondary Describe your needs for electricity. List the type of equipment you plan to use and how you intend to supply the necessary power. If electrical connections in the facility need to be adjusted for the event, an electrical permit may be required. Contact the Permit Section of the Department of Community Planning, Housing and Development at 703-228-3800.
          v-row(v-if="SEA_Permit_ElectricalRequired_11 === 'Yes'" :style={paddingLeft: '40px'})
            v-col(:lg="12" :md="12" :sm="12" :cols="12")
              validation-provider(rules="required", v-slot="{ errors }" immediate)
                v-textarea.pb-3.pl-3(outlined hide-details dense v-model="SEA_Permit_ElectricalNotes_11" :disabled="disabled" )
                p.pb-0.red--text.text--lighten-1.pl-4 {{ errors[0] }}
</template>


<script>
import { mapState } from "vuex";
import { mapFields } from "vuex-map-fields";
import store from "../store";
import o07sitePlanUpload from "./o07sitePlanUpload.vue";

export default {
  components: {
    o07sitePlanUpload,
  },
  store,
  computed: {
    ...mapState({
      data: (state) => state.data,
      yesNoString: (state) => state.yesNoString,
    }),
    ...mapFields([
      "data.SEA_MobileStage",
      "data.SEA_PlanUpload",
      "data.SEA_PlanURL",
      "data.SEA_Tents",
      "data.SEA_Permit_OCCRequired_5",
      "data.SEA_Permit_BUILDRequired_6",
      "data.SEA_AmusementDevices",
      "data.SEA_AmusementDeviceDesc",
      "data.SEA_Permit_ElectricalRequired_11",
      "data.SEA_Permit_ElectricalNotes_11",
      "data.id",
      "data.disabled",
    ]),
  },
  data: () => ({
    //
  }),
  methods: {
    //
  },
};
</script>